import { MessageBox } from "element-ui";

/**
 * 确认框
 * @param {String} params.text 提示文本
 * @param {Function} params.methods 确认后的回调函数
 * @returns
 */
let isConfirm = (params) => {
    return MessageBox.confirm(params.text, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
    })
        .then(() => {
            params.methods && params.methods();
        })
        .catch(() => { });
};

/**
 * 处理@用户
 * @param {String} content 输入内容
 * @param {Array} atUserIds @用户ID列表
 * @returns string 处理后的内容
 */
export let processAtUsers = (content, atUserIds)  => {
    // 匹配 @用户名#{数字} 的模式
    const atPattern = /(@[^#\s]+)#\{(\d+)\}/g;

    return content.replace(atPattern, (match, username, userId) => {
        // 将userId转换为数字进行比较
        const id = parseInt(userId, 10);

        // 如果用户ID在atUserIds数组中，则去掉#{数字}部分
        if (atUserIds.includes(id)) {
            return username;
        }

        // 如果不在数组中，保留原有内容
        return match;
    });
}

let isAdminRole = (role) => {
    return role === 'ADMIN' ||  role === 'SUPER_ADMIN'
}

let isSuperAdminRole = (role) => {
    return role === 'SUPER_ADMIN'
}

/**
 * 处理提示消息用户
 *
 * @param {String} content 输入内容
 * @returns string 处理后的内容
 */
export let processTipUsers = (content) => {
    // 匹配 #{用户名:id} 的模式
    const tipPattern = /#\{([^:}]+):(\d+)\}/g;
    
    return content.replace(tipPattern, (match, username, userId) => {
        // 只返回用户名部分，去除#{和:id}
        return username;
    });
}

export default {
    isConfirm,
    isAdminRole,
    isSuperAdminRole,
}